
import { useState, useEffect } from "react";
import { strapiDefaultUrl, strapiUrl } from "src/modules/users/constants";
import { UserDataRecordType } from "src/types/main";
import axios from "axios";
import { prefix } from "src/utils/users.utils";
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { isPWA } from "src/utils/mobile";
import { resolveResourceUrl } from "src/utils/url.utils";

export function useGetUsers() {
  const [users, setUsers] = useState<UserDataRecordType[]>([]);
  const [downloading, setDownloading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      async function getAllUsers() {
        if (downloading) {
          let allUsers: any = [];
          let page = 1;
          let keepGoing = true;
          const PAGE_SIZE = 500;

          try {
            while (keepGoing) {
              let token: string | null = null;

              if (!isPWA()) {
                const result = await SecureStoragePlugin.get({ key: 'accessToken' });
                token = result.value;
              }

              const headers = {
                Accept: "application/json;odata=nometadata",
                "Content-Type": "application/json;odata=nometadata",
              };

              if (token) {
                headers.Authorization = `Bearer ${token}`;
              }
              const res = await axios.get(`${strapiUrl}custom-users`, {
                params: {
                  pagination: {
                    page: page,
                    pageSize: PAGE_SIZE,
                  },
                  filters: { blocked: false },
                  fields: [
                    "id",
                    "username",
                    "email",
                    "PersonalNumber",
                    "City",
                    "Name",
                    "Position",
                    "Location",
                    "Department",
                    "DisplayName",
                  ],
                  populate: {
                    ManagerDev: {
                      fields: ["Name", "DisplayName"],
                    },
                    PictureUrl: {
                      fields: ["url"],
                    },
                  },
                },
                headers,
                withCredentials: true,
              });
              const { data, meta } = res.data;
              allUsers = [...allUsers, ...data];
              if (page >= meta.pagination.pageCount) {
                keepGoing = false; // достигли конца
              } else {
                page++;
              }
            }
          } catch (err: any) {
            console.error("Ошибка при получении пользователей:", err.message);
          }
          return allUsers;
        }
      }
      (async () => {
        const tempUsers = await getAllUsers();
        if (tempUsers && tempUsers.length > 0) {
          let users: any = [];
          tempUsers.forEach((user: any) => {
            users = [
              ...users,
              {
                FirstName:
                  (user.Name && user.Name.split(" ")[1]) ||
                  (user.DisplayName && user.DisplayName.split(" ")[1]),
                LastName:
                  (user.Name && user.Name.split(" ")[0]) ||
                  (user.DisplayName && user.DisplayName.split(" ")[0]),
                AccountName: prefix + user.email,
                apiGlobalID: user.PersonalNumber,
                abiGlobalID: user.PersonalNumber,
                PictureUrl:
                  (user.PictureUrl && resolveResourceUrl(user.PictureUrl.url, strapiDefaultUrl)) ||
                  null,
                PictureURL:
                  (user.PictureUrl && resolveResourceUrl(user.PictureUrl.url, strapiDefaultUrl)) ||
                  null,
                UserName: user.PersonalNumber,
                PreferredName: user.Name,
                PreferredNameRUS: user.Name,
                TitleRUS: user.Position,
                JobTitleRus: user.Position,
                JobTitle: user.Position,
                "SPS-Location": user.Location,
                Region: user.Location,
                DepartmentRUS: user.Department,
                Department: user.Department,
                BaseOfficeLocation: user.Location,
                ManagerFullNameRUS:
                  (user.ManagerDev && prefix + user.ManagerDev.Name) || null,
                WorkEmail: user.email,
              },
            ];
          });
          setUsers([...users]);
          setDownloading(false);
        }
      })();
    };

    fetchUsers(); // Запускаем загрузку

    return () => setDownloading(false); // Чистка эффекта, чтобы остановить загрузку при размонтировании компонента
  }, [downloading]);

  return { users, downloading };
}
